import ServiceCRUD from '../../../../../services/ServiceGasOrder';

class UnityService extends ServiceCRUD {
  constructor() {
    super(`/api/unidades-de-medida`);
  }
}

export default new UnityService();
